<template>
  <div v-if="selectAttCode">
    <!--设置value便于父组件与子组件通信-->
    <tabs v-model="activeName">
      <pane name="1" :label="this.$t('attendanceCode.attendanceCodeList')">
        <workCodeInfo :selectAttCode="selectAttCode"></workCodeInfo>
      </pane>
      <pane name="2" :label="this.$t('attendanceCode.assignment')">
        <workCodeDevice  :selectAttCode="selectAttCode"></workCodeDevice>
      </pane>
    </tabs>
  </div>
</template>
<script>
import workCodeInfo from './workCodeInfo'
import workCodeDevice from './workCodeDevice'
export default {
  data () {
    return {
      activeName: '1'
    }
  },
  props: {
    selectAttCode: {
      type: Object,
      function () {
        return {}
      }
    }
  },
  components: {
    workCodeInfo,
    workCodeDevice
  },
  mounted () {
  }
}
</script>
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/attendanceCode/workCode.vue